export default __webpack_public_path__ + "static/media/icon-Connect-Collaboration.5ca274d8.svg";